module.exports = __webpack_public_path__ + "img/samplering@2x.40e1737.jpg";